<template>
  <div class="nx-signing-modal-merge-doc">
    <h4>{{$t('MergingSign')}}</h4>

    <h5 class="mt-4">{{$t('PleaseWait')}}</h5>

    <div class="mt-4">
      <b-spinner />
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';
import { SignApi } from '@/api';


export default {
  components: {
    BSpinner
  },
  props: {
    value: {},
    username:"",
    password:"",
    guid:""
  },
  async created() {
    if (this.value.signMethod !== 'SIGN_IAM_SMART'){
      
    try {
      const { signatures, cert } = this.value;
      var files = signatures.map((x) =>
        ({
          digest:x.digest,
          signature:x.signature, 
          fileID: x.fileID
        }));
        if(!files[0]?.signature){
          this.$emit('input', this.$t('SigningClientFailed'));
          this.$emit('fail');
        }else{
          if(this.value?.guid){
            await SignApi.registorWithECert({digest: files[0].digest,signature:files[0].signature,guid:this.value.guid});
          }else{
            await SignApi.loginWithECert({digest: files[0].digest,signature:files[0].signature,username:this.username,password:this.password});            
          }
          this.$emit('next');
        }
    } catch (ex) {
      this.$emit('input', ex.response?.data?ex.response?.data:ex.response);
      this.$emit('fail');

      throw ex;
    }
    }else{
      this.$emit('next');
    }
  },
  i18n: {
    messages: {
      en: {
        MergingSign: 'Merging signature to document',
        PleaseWait: 'Please wait... Almost finish',
        SigningClientFailed:'Failed to get response from signing client, please try again.'
      },
      zh_hk: {
        MergingSign: '將簽名合併到文檔',
        PleaseWait: '請稍等...即將完成',
        SigningClientFailed:'簽名客戶端沒有回應,請重新輸入'
      },
      zh_cn: {
        MergingSign: '将签名合并到文档',
        PleaseWait: '请稍等...即将完成',
        SigningClientFailed:'签名客户端没有回应,请重新输入'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-merge-doc {
  text-align: center;
}
</style>
